<template>
	<div class="qualityenterprise">
		<leftnav class="fl" mkcode="R" itemcode="A-WZQY" docutitle="外资招商"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" style="padding-bottom: 1px;">
					<div class="right_boxtitle">
						<span class="fl right_title">外资招商</span>
						<div class="fl search-box ot-search-box">
							<span class="searchtype">{{title}}</span>
							<input type="text" placeholder="请输入企业名称" class="search-input" v-model="searchtext"	@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div>
					</div> 
				<div class="opport-screen-list1">
							<dl class="opport-screen bdbe">
								<dt class="fl">企业类型</dt>
								<dd class="fl">
									<span class="a-screen" @click="routerself('/foreignEnterprises')">外资企业库(按注册地)</span>
									<span class="a-screen" @click="routerself('/foreignInvestment')">外资企业库(按来源国)</span>
									<span class="a-screen" @click="routerself('/foreignEnterprises')">全球上市企业库</span>
									<span class="a-screen current">海外机构名录</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe">
								<dt class="fl">所在大洲</dt>
								<dd class="fl"> 
									<span @click="chooseCountry({id:0,name:'全部'},1);"	:class="continentId == 0?'a-screen current' : 'a-screen'">全部</span>
									<span v-for="(item,index) in continentList" :key="index"	@click="chooseCountry(item,1);"	:class="item.id == continentId?'a-screen current' : 'a-screen'">{{item.name}}</span>
								</dd>
							</dl>
                            <dl class="opport-screen bdbe" v-show="countryList.length>0">
								<dt class="fl">所在国家</dt>
								<dd class="fl"> 
									<span @click="chooseCountry({id:0,name:'全部'},2);"	:class="countryId == 0?'a-screen current' : 'a-screen'">全部</span>
									<span v-for="(item,index) in countryList" :key="index"	@click="chooseCountry(item,2);"	:class="item.id == countryId?'a-screen current' : 'a-screen'">{{item.name}}</span>
								</dd>
							</dl>
                            <dl class="opport-screen bdbe">
								<dt class="fl">机构类型</dt>
								<dd class="fl"> 
									<span @click="chooseOrgId({id:0,name:'全部'});"	:class="orgId == 0?'a-screen current' : 'a-screen'">全部</span>
									<span v-for="(item,index) in orgList" :key="index"	@click="chooseOrgId(item);"	:class="item.id == orgId?'a-screen current' : 'a-screen'">{{item.name}}</span>
								</dd>
							</dl>
						</div>
					</div> 
				<div class="whitebox" style="min-height: 160px;" :data="exportnum">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<p class="fl" v-if="kwtextsearch">产业大脑为您找到<span 	class="searchnum">{{total}}</span>条【 <span class="orangefont">{{kwtextsearchtext}}</span>】相关结果</p>
						
					</div> 
					<div class="enterprise_list_box" v-show="enterpristlist.length!=0"> 
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>机构名称</th>
								<th>机构类型</th>
								<th>联系人</th>
                                <th>电话</th>
								<th>邮箱</th>
								<th>地址</th>
								<th>详情</th>
							</tr> 
							<tr v-for="(list,index) in enterpristlist" :key="index">
								<td class="title" @click="routerlinkid('/orgDetail',list.id)">{{list.orgName}}</td>
								<td>{{list.orgType}}</td>
								<td>{{list.concat}}</td>
								<td>{{list.phone}}</td>
								<td>{{list.email}}</td>
								<td>{{list.address}}</td>
								<td class="collectfont1">
                                    <span @click="routerlinkid('/orgDetail',list.id)">详情 ></span>
                                </td>
							</tr>
						</table> 
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { name } from "echarts-extension-amap";
import {
		dataInJs
	} from "../../utils/city.js";
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'forcapEnterprise',
		computed: {
		...mapState({
		// isCollapse: (state) => state.app.isCollapse,
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				title: "外资企业库",
				curWebsite:this.$api.getWebsiteType(),   
				industrytype:1,
				enterinarr: [
				{curindex: 1,type: 9,name: "龙头企业库",tagnum:10010,}, 
				{curindex: 2,type: 2,name: "科创企业库",tagnum:10010,},
				],
					
				tz_enterinarr:[
					{curindex: 1,type: 9,name: "上市公司",tagnum:10010,url:'markingEnterpriseist?type=9'},
					{curindex: 2,type: 1,name: "龙头企业",tagnum:10010,url:'markingEnterpriseist?type=1'},
					{curindex: 3,type: 0,name: "全部内资企业",tagnum:10010,url:'markingEnterpriseist?type=0'}, 
				],
				hotindustry:[],hotindustrychild:[], industrycode1:"",industrycode2:'',industryid:0,
				levelList:[{text:'全部',code:0},{text:'中国总部',code:1},{text:"其他企业",code:2}],levelid:0,
				curindex: 5, 
				islogin: false,
				userdata: {}, 
				searchtext: "",
				kwtextsearch: false,
				kwtextsearchtext: "", 
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数  
				provinceid: 0,
				cityid: 0,
				countyid: 0,
				provincedata: [],
				citydata: [],
				countydata: [], 
				enterpristlist: [],  
				orderField: 0, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序    
				exportnum: 0, //导出次数
				exportpop: false, //点击导出按钮弹框显示
				allowexport: false, //后台判断是否可以上传
				exportbtn: true, //loading小 等待转圈圈
				isShowFreeUserTips:false,
                continentList:[],
                countryList:[],
                continentId:0,
                countryId:0,
                orgList:[],
                orgId : 0,
			}
		},
		beforeCreate() {
			// this.bus.$emit('loading', true);
		},  
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			var _this = this;
			this.userdata = this.getuseriformation();
            this.getPrams();
		},
		mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
			// console.log('sercatype:', this.searchtype); 
			this.getCompanyList();
 
		},
		methods: {  
            chooseOrgId(item){
                this.orgId = item.id; 
                this.getCompanyList();
            },
            chooseCountry(item,step){
                console.log(item,step)
                if(step == 1){
                    this.continentId = item.id;
                    this.countryList = item.country || [];
                }else if(step == 2){
                    this.countryId = item.id;
                }
                this.getCompanyList();
            },
            getPrams(){
                let ajaxurl = this.$api.cyl.foreignOrg.paramList();
                this.$axios.get(ajaxurl, {
                    headers: {
                        AuthToken: this.userdata.token
                    }
                }).then((res) => {
                    if (res.data.success) {
                        this.continentList = res.data.list;
						this.orgList = res.data.data.orgType || [];
                    }
                })
            },
			getajaxUrl(apiurl) { 
				var industryja1 =this.splicing('industry',this.industrycode1);
				var industryja2 =this.splicing('industry2',this.industrycode2); 
				var kwaja =this.splicing('kw',this.searchtext); 
				var countyidja =this.splicing('county',this.countyid);
				var provinceidja =this.splicing('province',this.provinceid);
				var cityidja =this.splicing('city',this.cityid); 
				var levelja =this.splicing('level',this.levelid); 
				apiurl = apiurl + "?orderField=" + this.orderField + "&orderType=" + this.orderType+kwaja+industryja1+industryja2+countyidja+provinceidja+cityidja + levelja;
				return apiurl;
			},
			//搜索关键词
			searchkwfun() {
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					this.searchtext="";
					return;
				}
				this.searchtext = $.trim(this.searchtext);
				// if(this.searchtext!="" || ){
				this.getCompanyList(1,'search');
				// } 
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			},
			pageHandler: function(page) {  
				this.getCompanyList(page,'search'); 
			}, 
			getCompanyList(pages) {
				this.bus.$emit('loading', true); 
				this.page=pages?pages:1; 
                var _this = this;
                let continent = this.splicing('continent',this.continentId);
                let country = this.splicing('country',this.countryId);
				let city = this.splicing('city',this.cityid);
                let orgType = this.splicing('orgType',this.orgId);
                let kw = this.splicing('kw',this.searchtext);
				var ajaxurl = this.$api.cyl.foreignOrg.list() + '?page=' + this.page +continent+country+orgType+kw;
				// console.log(ajaxurl)
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {  
					
					if (res.data.success) {
                        let dataenterlist = res.data.list;
						//页数和导出
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
                        
						_this.haspage = res.data.list.length == res.data.pageSize; 
						_this.kwtextsearch = _this.searchtext != "";
						_this.kwtextsearchtext = _this.searchtext;
						_this.enterpristlist=dataenterlist; 
                        console.log('外资企业列表', res.data);
						_this.bus.$emit('loading', false);
					} else {
						
					}
				}).catch(function(error) {});
				// console.log(datas);  
			},
			//省份城市选择
			provincechoose(id, i) {
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				if(this.provinceid != id){ 
					this.ttsg();
					this.cityid = 0;
					this.countyid = 0;
					this.page = 1;
					this.provinceid = id; 
					this.countydata = [];
					if (i != "all" && this.provincedata[i].children != null) {
						this.citydata = this.provincedata[i].children; 
					} else {
						this.citydata = [];  
					}
						this.getCompanyList(1,'sort'); 
				}
			},
			ttsg(){
				// this.notionlist1=[];
				// this.notionlist2=[];
				// this.notionlist3=[];
				// this.notionlist4=[];
				// this.notionlist5=[];
				// this.notionCode=0;this.chooseNotionlist=[0,0,0,0,0,0];
			},
			choosecity(id, i) {
				//	console.log('choosecity',id);
					if(this.cityid != id){ 
					this.ttsg();
						this.cityid = id;
						this.countyid = 0;
						if (i != "all" && this.citydata[i].children != null) {
							this.countydata = this.citydata[i].children;
						} else {
							this.countydata = [];
						}
						this.page = 1;
						this.getCompanyList(1,'sort');
				}
			},
			choosecounty(id) {
				//	console.log('choosecity',id);
				this.countyid = id;
				this.page = 1;
				this.getCompanyList();
			}, 
			//  
		}
	}
</script>

<style>
</style>
